export default function getCountryByOrder(o) {
    return o.country;
}